import React, { PropsWithChildren } from 'react'
// import './integrations-col.scss'

import classnames from 'classnames'
import { Flex } from 'antd'
import { VERTICAL_WELL_GAP } from '../../../theme/constants'

type IntegrationsColProps = {
    loading?: boolean
    className?: string
    label: string
}

export const IntegrationsCol: React.FC<PropsWithChildren<IntegrationsColProps>> = ({
    loading,
    label,
    className,
    children,
}) => {
    return (
        <Flex
            align="center"
            vertical
            gap={VERTICAL_WELL_GAP}
            className={classnames('integrations-col', className, { loading })}
        >
            <div className="font-weight--bold fg--color--gray-2">{label}</div>
            <Flex vertical gap={VERTICAL_WELL_GAP} className="integrations-col-content">
                {children}
            </Flex>
        </Flex>
    )
}
